/// <reference path="../typings/browser.d.ts" />
import { LoginApi, emptyRequest } from '@deltasierra/shared';
import { IHttpService } from 'angular';
import { Future } from '../common/Future';
import { $httpSID, $locationSID, ILifecycleHooks } from '../common/angularData';
import { invokeApiRoute } from '../common/httpUtils';
import { InteractionUtils } from '../common/interactionUtils';
import { MvNotifier } from '../common/mvNotifier';
import { I18nService } from '../i18n';
import { LoginFlowService } from './loginFlowService';
import { MvIdentity } from './mvIdentity';
import ILocationService = angular.ILocationService;

type LoginActionContext = {
    password: string;
    requestToken?: string;
    username: string;
};

export class LoginController implements ILifecycleHooks {
    public static readonly SID = 'mvLoginCtrl';

    public loginAttempts = 0;

    public username: string | null = null;

    public password: string | null = null;

    public requestToken?: string = undefined;

    public isExternalLoginRequest = false;

    public loginAction: Future<void, LoginActionContext>;

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static readonly $inject: string[] = [
        $httpSID,
        $locationSID,
        MvIdentity.SID,
        LoginFlowService.SID,
        InteractionUtils.SID,
        'mvNotifier',
        I18nService.SID,
    ];

    public constructor(
        private readonly $http: IHttpService,
        $location: ILocationService,
        public readonly identity: MvIdentity,
        private readonly loginFlowService: LoginFlowService,
        interactionUtils: InteractionUtils,
        private mvNotifier: MvNotifier,
        private i18n: I18nService,
    ) {
        if (typeof this.$onInit === 'function') {
            // Call $onInit manually if defined
            this.$onInit();
        }
        const params = $location.search();
        if (params.requestToken) {
            this.requestToken = params.requestToken;
            this.isExternalLoginRequest = true;
        }

        if (identity.isAuthenticated() && !this.isExternalLoginRequest) {
            this.loginFlowService.redirect();
        } else if (params.username) {
            this.username = params.username;
        } else if (identity.isAuthenticated()) {
            this.username = identity.currentUser!.username;
        }

        if (params.o === '4') {
            this.mvNotifier.notify(this.i18n.text.login.passwordResetPleaseLogin());
        }

        this.loginAction = interactionUtils.createFuture('login', ({ password, requestToken, username }: LoginActionContext) =>
            this.loginFlowService.login(username, password, requestToken),
        );
    }

    public async $onInit(): Promise<void> {
        const response = await invokeApiRoute(this.$http, LoginApi.getLoginMethod, emptyRequest());
        if (response && response.isV2AppAuthEnabled && response.appFrontendUrl) {
            window.location.replace(`${response.appFrontendUrl}/login`);
        }
    }

    public signin(username: string, password: string): ng.IPromise<void> {
        return this.loginAction.run({ password, requestToken: this.requestToken, username });
    }

    public isConfirmingIdentity() {
        return this.isExternalLoginRequest && this.identity.isAuthenticated();
    }
}

angular.module('app').controller(LoginController.SID, LoginController);
